export default {
  UPDATE_ADDRESS: 'AVAILABILITY/UPDATE_ADDRESS',
  UPDATE_ELIGIBILITY: 'AVAILABILITY/UPDATE_ELIGIBILITY',
  UPDATE_PRODUCT_MAP: 'AVAILABILITY/UPDATE_PRODUCT_MAP',
  VERIFIED_ADDRESS: 'AVAILABILITY/VERIFIED_ADDRESS',
  RESET_MODAL: 'AVAILABILITY/RESET_MODAL',
  WINDOW_CATEGORY_MAPPINGS: 'AVAILABILITY/WINDOW_CATEGORY_MAPPINGS',
  MOUNT_TYPES: 'AVAILABILITY/MOUNT_TYPES',
  SPEC_MAPPINGS: 'AVAILABILITY/SPEC_MAPPINGS',
};
